/* Delegated handlers also work when sections are reloaded by the theme editor. */
(function () {
  'use strict';
  var busy = false;
  var buttonStates = [];
  function lockButtons() {
    buttonStates = Array.from(document.querySelectorAll('[data-bhc-add]')).map(function (button) {
      var state = { button: button, disabled: button.disabled };
      button.disabled = true;
      return state;
    });
  }
  function unlockButtons() {
    buttonStates.forEach(function (state) { state.button.disabled = state.disabled; });
    buttonStates = [];
    busy = false;
  }
  window.addEventListener('pageshow', function () {
    unlockButtons();
    document.querySelectorAll('form[aria-busy]').forEach(function (form) { form.removeAttribute('aria-busy'); });
    document.querySelectorAll('[data-bhc-original-label]').forEach(function (button) {
      button.innerHTML = button.dataset.bhcOriginalLabel;
      delete button.dataset.bhcOriginalLabel;
    });
  });
  document.addEventListener('submit', async function (event) {
    var form = event.target;
    var button = form.querySelector('[data-bhc-add]');
    if (!button) return;
    event.preventDefault();
    if (busy || button.disabled) return;
    var error = document.getElementById(button.dataset.errorId);
    var recovery = form.querySelector('.bhc-cart-recovery');
    var data = new FormData(form);
    var cartURL = data.get('return_to');
    busy = true;
    error.hidden = true;
    recovery.hidden = true;
    lockButtons();
    form.setAttribute('aria-busy', 'true');
    button.dataset.bhcOriginalLabel = button.innerHTML;
    button.textContent = 'ADDING…';
    var confirmedFailure = false;
    try {
      var endpoint = new URL(form.action, window.location.origin);
      endpoint.pathname = endpoint.pathname.replace(/\/add\/?$/, '/add.js');
      var response = await fetch(endpoint.toString(), { method: 'POST', body: data, headers: { 'Accept': 'application/json' } });
      var result = await response.json();
      if (!response.ok || result.status) {
        confirmedFailure = response.status >= 400 && response.status < 500;
        throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please check your cart and try again.');
      }
      window.location.assign(cartURL);
    } catch (failure) {
      error.textContent = confirmedFailure ? failure.message : 'We could not confirm your cart. Check it before trying again so you do not add the Reset twice.';
      error.hidden = false;
      recovery.hidden = false;
      button.innerHTML = button.dataset.bhcOriginalLabel;
      delete button.dataset.bhcOriginalLabel;
      form.removeAttribute('aria-busy');
      // Do not retry an uncertain request: it may already have reached Shopify.
      if (confirmedFailure) unlockButtons();
    }
  });
  document.addEventListener('toggle', function (event) {
    var detail = event.target;
    if (detail.matches && detail.matches('.bhc-faq details') && detail.open) {
      detail.closest('.bhc-faq').querySelectorAll('details').forEach(function (other) { if (other !== detail) other.open = false; });
    }
  }, true);
}());
